if (process.env.NODE_ENV === 'development') {
  var serverURI = 'https://api.wexcedo.com/' 
} else if (process.env.NODE_ENV === 'production') {
  serverURI = process.env.VUE_APP_API + '/'
}

export default {
  serverURI: serverURI
}
